import React from 'react'
import Login from '../components/Login'

const SignInPage = () => {
  return (
    <>
      <Login />
    </>
  )
}

export default SignInPage